import React from 'react';
import MixedCompetitionConfig from './MixedCompetitionConfig';

export default function ConfigMiste(props) {
  // Wrapper per mantenere naming coerente con la route /config-miste
  return <MixedCompetitionConfig {...props} />;
}
